<template>
    <div class="modal fade"
         :style="'cursor: url('+cursorImage()+'), auto !important'"
         :id="modalId" tabindex="-1"
         role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered custom-modal" role="document">
            <div class="modal-content">
                <div class="modal-body d-flex flex-column justify-content-center modal-alert">
                    <app-pre-loader v-if="loading"/>
                    <template v-else>
                        <div class="text-center">
                            <app-icon :class="'text-'+(modalClass?modalClass:'danger')" :name="icon?icon:'x-circle'"/>
                        </div>

                        <h5 class="text-center font-weight-bold mt-4">
                            One or more order items do not have the Delivery Date, Delivery Mode,
                            or Tracking info fields updated.
                        </h5>

                        <p v-if="subTitle" class="text-center font-size-90 m-0 p-0">
                            {{ subTitle }}
                        </p>

                        <div class="text-center mt-3">
                            <a v-if="!hideSecondButton"
                               href="#"
                               class="btn btn-secondary mr-2"
                               data-dismiss="modal"
                               @click.prevent="cancelled">
                                {{ secondButtonName ? secondButtonName : $t('ok') }}
                            </a>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppFunction from "../../helpers/app/AppFunction";

export default {
    name: "OrderErrorModal",
    props: {
        modalId: { type: String, required: true },
        message: String,
        firstButtonName: String,
        secondButtonName: String,
        title: String,
        subTitle: String,
        icon: String,
        modalClass: String,
        selfClose: { type: Boolean, default: true },
        loading: { type: Boolean, default: false },
        hideFirstButton: { type: Boolean, default: false },
        hideSecondButton: { type: Boolean, default: false }
    },
    mounted() {
        $('#' + this.modalId).on('hidden.bs.modal', () => {
            this.closed();
        });
        $('#' + this.modalId).modal('show');
    },
    methods: {
        cursorImage() {
            return this.$store.state.theme.darkMode
                ? AppFunction.getAppUrl('images/close-cursor-dark.png')
                : AppFunction.getAppUrl('images/close-cursor-light.png');
        },
        confirmed() {
            this.$emit('confirmed', false);
        },
        cancelled() {
            this.closed();
        },
        closed() {
            this.$emit('cancelled', false);
        }
    }
}
</script>

<style>
/* Smaller modal width */
.custom-modal {
    max-width: 500px !important;
}

.custom-modal .modal-content {
    border-radius: 10px;
    padding: 10px;
}
</style>
